export default __webpack_public_path__ + "static/media/od-b-wrong_s.a623314d.jpg";